<script>
  import { scaleX } from 'util/Transitions';
  import { afterUpdate } from 'svelte';
  import { t } from 'precompile-intl-runtime';
  import draft from 'stores/Draft';
  import saveIcon from 'icons/save.svg';

  $: isSaving = false;
  let saveButton;
  let name;
  let downloadInput;

  function exportToFile(event) {
    console.log('?');
    event.preventDefault();
    const blob = new Blob([JSON.stringify($draft)], {
      type: 'text/json',
    });
    const link = document.createElement('a');

    link.download = name + '.json';
    link.href = window.URL.createObjectURL(blob);
    link.dataset.downloadurl = ['text/json', link.download, link.href].join(
      ':'
    );

    const evt = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    });

    link.dispatchEvent(evt);
    isSaving = false;
  }

  function blurMeMaybe(event) {
    if (event.relatedTarget !== saveButton) {
      isSaving = false;
    }
  }

  afterUpdate(() => {
    if (isSaving === true) {
      downloadInput.focus();
    }
  });
</script>

{#if !isSaving}
  <button class="icon-button save-load" on:click={() => (isSaving = true)}>
    <span>{$t('terms.save')}</span>
    <div class="icon">
      {@html saveIcon}
    </div>
  </button>
{:else}
  <form transition:scaleX class="download" on:submit={exportToFile}>
    <input
      type="text"
      bind:value={name}
      bind:this={downloadInput}
      on:blur={blurMeMaybe}
    />
    <button
      bind:this={saveButton}
      type="button"
      on:click={exportToFile}
      class="icon-button save-load">√</button
    >
  </form>
{/if}

<style>
  .download {
    display: flex;
    flex-direction: row;
  }

  .download input {
    width: 7rem;
    transition-property: width;
    transition-duration: 300ms;
    margin-left: 10px;
  }

  .icon-button {
    border-radius: 4px;
    border: 1px black;
    color: var(--color-1);
    background-color: #40362a;
    margin: 10px;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .save-load {
    height: 50px;
    color: var(--color-1);
    text-align: center;
  }

  .icon-button:hover {
    background-color: var(--color-2);
  }

  .icon {
    fill: var(--color-1);
    stroke: var(--color-1);
    width: 20px;
    height: 20px;
    margin-left: 0.5rem;
    margin-bottom: 5px;
    display: inline-block;
  }
</style>
